module.exports = __webpack_public_path__ + "a1f10dd9c7c38d56040f541480b407f6.svg";